import { useMemo } from 'react'
import { query, where } from 'firebase/firestore'
import { eventInterestsCol } from '../lib/converters'
import { useBatchedSubscriptions } from './useBatchedSubscriptions'
import { attendanceStatus, type EventAttendanceStatus } from '../types'

const EMPTY: Record<string, EventAttendanceStatus> = {}

export function useGroupMemberStatuses(memberIds: string[], eventId: string) {
  const { rows, loading } = useBatchedSubscriptions<{ userId: string; status: EventAttendanceStatus }>(
    memberIds,
    batch =>
      query(
        eventInterestsCol(),
        where('userId', 'in', batch),
        where('eventId', '==', eventId),
      ),
    d => {
      const data = d.data()
      return { userId: data.userId, status: attendanceStatus(data.status) }
    },
    { queryKey: eventId },
  )

  const statuses = useMemo(() => {
    if (rows.length === 0) return EMPTY
    const result: Record<string, EventAttendanceStatus> = {}
    rows.forEach(({ userId, status }) => {
      result[userId] = status
    })
    return result
  }, [rows])

  return { statuses, loading }
}
